import { render, staticRenderFns } from "./NewTaskOverview.vue?vue&type=template&id=00c7bfdf"
import script from "./NewTaskOverview.vue?vue&type=script&lang=js"
export * from "./NewTaskOverview.vue?vue&type=script&lang=js"
import style0 from "./NewTaskOverview.vue?vue&type=style&index=0&id=00c7bfdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports